import React from 'react';
import { PageDefinition } from '../../createRoutes';
import Page from '../../layouts/Page';
import Content from './Content';

export const forecastPage: PageDefinition = {
    path: '/forecast',
    Component() {
        return (
            <Page breadcrumbs={{ name: 'Forecast' }}>
                <Content />
            </Page>
        );
    },
};
